export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/account/login"),
        meta: {
            title: "Login",
            // beforeResolve(routeTo, routeFrom, next) {
            //     const currentUser = store.store.state.auth.currentUser;
            //     if (currentUser && Object.keys(currentUser).length > 0) {
            //         next({name: "dashboard"});
            //     } else {
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/esqueceu-senha",
        name: "forgot-password",
        component: () => import("@/views/account/forgot-password.vue"),
        meta: {
            title: "Recuperar Senha",
        },
    },
    {
        path: "/recuperar-senha",
        name: "change-password",
        component: () => import("@/views/account/change-password.vue"),
        meta: {
            title: "Resetar Senha",
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("@/views/account/logout"),
        meta: {
            title: "Logout",
        },
    },
    {
        path: "/",
        name: "dashboard",
        meta: {
            title: "Dashboard",
            authRequired: true,
        },
        component: () => import("@/views/dashboard/index"),
    },

    {
        path: "/meu-perfil",
        name: "my-profile",
        meta: {
            title: "Meu Perfil",
            authRequired: true,
        },
        component: () => import("@/views/profile/my-profile.vue"),
    },

    {
        path: "/usuarios",
        name: "users",
        meta: {
            title: "Usuários",
            authRequired: true,
        },
        component: () => import("@/views/management/users.vue"),
    },

    {
        path: "/clientes",
        name: "companies",
        meta: {
            title: "Clientes",
            authRequired: true,
        },
        component: () => import("@/views/companies/index.vue"),
    },

    {
        path: "/clientes/cadastrar/:id?",
        name: "companies-form",
        meta: {
            title: "Cadastro de Cliente",
            authRequired: true,
        },
        component: () => import("@/views/companies/form.vue"),
    },

    {
        path: "/planos",
        name: "plans",
        meta: {
            title: "Planos",
            authRequired: true,
        },
        component: () => import("@/views/plans/index.vue"),
    },
];
    